import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const AdminDashboardOverview = () => {
  const [stats, setStats] = useState({
    totalRoutes: 0,
    totalUsers: 0,
    toPayCount: 0,
    transactionsCount: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [routesRes, usersRes, paymentsRes, transactionsRes] = await Promise.all([
        axios.get('/api/admin/routes'),
        axios.get('/api/admin/users'),
        axios.get('/api/admin/payments'),
        axios.get('/api/admin/transactions')
      ]);

      const routes = routesRes.data;
      
      // Count payments with toPay > 0
      const payments = paymentsRes.data || [];
      const toPayCount = payments.filter(p => p.toPay && p.toPay > 0).length;
      
      // Count total transactions
      const transactions = transactionsRes.data || [];
      const transactionsCount = transactions.length;

      setStats({
        totalRoutes: routes.length,
        totalUsers: usersRes.data.length,
        toPayCount,
        transactionsCount
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando panel...</div>;
  }

  return (
    <div className="container">
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '16px', 
        marginBottom: '40px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e5e7eb'
      }}>
        <img src="/logo.svg" alt="Logo" style={{ height: '56px', width: 'auto' }} />
        <div>
          <h2 style={{ margin: 0, color: '#1e40af', fontSize: '32px', fontWeight: '600' }}>Resumen del Panel</h2>
          <p style={{ margin: '5px 0 0 0', color: '#6b7280', fontSize: '14px' }}>
            Vista general del sistema de gestión de transporte
          </p>
        </div>
      </div>
      
      <div className="dashboard-grid" style={{ marginBottom: '32px' }}>
        <Link to="/admin/routes" className="dashboard-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h3 style={{ color: '#6b7280', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>🛣️ Total de Rutas</h3>
            <span style={{ fontSize: '24px' }}>→</span>
          </div>
          <p style={{ fontSize: '42px', fontWeight: '700', color: '#1e40af', margin: '0 0 12px 0', lineHeight: '1' }}>{stats.totalRoutes}</p>
          <span style={{ color: '#1e40af', fontSize: '14px', fontWeight: '500' }}>Ver Todas las Rutas</span>
        </Link>

        <Link to="/admin/users" className="dashboard-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h3 style={{ color: '#6b7280', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>👥 Total de Usuarios</h3>
            <span style={{ fontSize: '24px' }}>→</span>
          </div>
          <p style={{ fontSize: '42px', fontWeight: '700', color: '#10b981', margin: '0 0 12px 0', lineHeight: '1' }}>{stats.totalUsers}</p>
          <span style={{ color: '#10b981', fontSize: '14px', fontWeight: '500' }}>Gestionar Usuarios</span>
        </Link>

        <Link to="/admin/payments" className="dashboard-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h3 style={{ color: '#6b7280', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>💰 A Pagar</h3>
            <span style={{ fontSize: '24px' }}>→</span>
          </div>
          <p style={{ fontSize: '42px', fontWeight: '700', color: '#f59e0b', margin: '0 0 12px 0', lineHeight: '1' }}>{stats.toPayCount}</p>
          <span style={{ color: '#f59e0b', fontSize: '14px', fontWeight: '500' }}>Gestionar Pagos</span>
        </Link>

        <Link to="/admin/transactions" className="dashboard-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
            <h3 style={{ color: '#6b7280', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>📊 Transacciones</h3>
            <span style={{ fontSize: '24px' }}>→</span>
          </div>
          <p style={{ fontSize: '42px', fontWeight: '700', color: '#10b981', margin: '0 0 12px 0', lineHeight: '1' }}>{stats.transactionsCount}</p>
          <span style={{ color: '#10b981', fontSize: '14px', fontWeight: '500' }}>Ver Historial</span>
        </Link>
      </div>

      <div className="card" style={{
        borderRadius: '12px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb',
        padding: '24px'
      }}>
        <h3 style={{ 
          marginBottom: '20px', 
          color: '#1e40af',
          fontSize: '20px',
          fontWeight: '600',
          paddingBottom: '12px',
          borderBottom: '2px solid #e5e7eb'
        }}>
          ⚡ Acciones Rápidas
        </h3>
        <div className="flex-container" style={{ 
          display: 'flex', 
          gap: '12px', 
          flexWrap: 'wrap' 
        }}>
          <Link 
            to="/admin/routes/designate" 
            className="btn btn-primary"
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '500',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            ➕ Designar Nueva Ruta
          </Link>
          <Link 
            to="/admin/users" 
            className="btn btn-success"
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '500',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            👤 Agregar Nuevo Usuario
          </Link>
          <Link 
            to="/admin/routes" 
            className="btn btn-secondary"
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '500',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            🛣️ Ver Todas las Rutas
          </Link>
          <Link 
            to="/admin/payments" 
            className="btn btn-secondary"
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '500',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            💰 Gestionar Pagos
          </Link>
          <Link 
            to="/admin/transactions" 
            className="btn btn-secondary"
            style={{
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '500',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            📊 Ver Transacciones
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardOverview;
